function staffUtilizationStatus({ availabilityForDayOfWeek, bookingCount, blockoutCount }) {
  if(bookingCount > 0) {
    return 'assigned'
  }
  else if(blockoutCount > 0) {
    return 'unavailable'
  }
  else if (availabilityForDayOfWeek == "yes") {
    return 'available'
  }
  else if (availabilityForDayOfWeek == "partial") {
    return 'partial'
  }
  else if (availabilityForDayOfWeek == "no") {
    return 'unavailable'
  }
  else {
    throw new Error(`Unknown availabilityForDayOfWeek: ${availabilityForDayOfWeek}`)
  }
}

export default staffUtilizationStatus
